<div class="mb-4 overflow-hidden rounded-lg border border-neutral-gray30">
  <div class="bg-white p-6">
    <h3 class="mb-4 text-lg font-medium text-neutral-gray70">{{ title | translate }}</h3>

    <p class="mb-6 text-sm leading-relaxed text-neutral-gray60">
      {{ description | translate }}
    </p>

    <div class="flex flex-col items-center justify-center py-8">
      <img src="assets/images/question.svg" alt="Coming Soon" class="mb-4 h-16 w-16" />
      <p class="text-lg font-medium text-neutral-gray70">
        {{ title | translate }} {{ 'modules.profile_settings.subscription.coming_soon' | translate }}
      </p>
      <p class="mt-2 text-sm text-neutral-gray50">
        {{ 'modules.profile_settings.subscription.under_development' | translate }}
      </p>
    </div>
  </div>
</div>
